import { BaseBffHttpService } from '../BaseBffHttpService';

export class UserHttpService extends BaseBffHttpService {
  protected readonly basePath = 'user';

  async updateProfile(displayName: string): Promise<Response> {
    return this.put(this.basePath, { displayName });
  }
}
